<template>
  <div>
    <b-row>
      <b-col cols="6">
        <h4>Heute</h4>
        <b-row>
          <statistic-card-vertical
            v-ripple.400="'rgba(0, 207, 232, 0.15)'"
            v-b-tooltip.hover.v-info
            icon="UserCheckIcon"
            color="info"
            :statistic="statistics.today.passengers"
            statistic-title="Personen"

            style="max-width:160px"
            class="ml-2 col-3"
            title="Transportierte Fahrgäste"
            variant="outline-info"
          />
          <statistic-card-vertical
            v-ripple.400="'rgba(0, 207, 232, 0.15)'"
            v-b-tooltip.hover.v-info
            icon="NavigationIcon"
            color="info"
            :statistic="statistics.today.km"
            statistic-title="KM"

            style="max-width:160px"
            class="ml-2 col-3"
            title="Zurückgelegte Kilometer mit Fahrgästen"
            variant="outline-info"
          />
          <statistic-card-vertical
            v-ripple.400="'rgba(0, 207, 232, 0.15)'"
            v-b-tooltip.hover.v-info
            icon="DollarSignIcon"
            color="info"
            :statistic="statistics.today.sales"
            statistic-title="euro"

            style="max-width:350px"
            class="ml-2"
            title="Umsatz"
            variant="outline-info"
          />
          <statistic-card-vertical
            v-ripple.400="'rgba(0, 207, 232, 0.15)'"
            v-b-tooltip.hover.v-info
            icon="TruckIcon"
            color="info"
            :statistic="statistics.today.voucher"
            statistic-title="Voucher"

            style="max-width:160px"
            class="ml-2 col-3"
            title="Fahrten"
            variant="outline-info"
          />
        </b-row>
      </b-col>

      <b-col cols="6">
        <h4 class="ml-1">
          Gestern
        </h4>
        <b-row>
          <statistic-card-vertical
            v-ripple.400="'rgba(0, 207, 232, 0.15)'"
            v-b-tooltip.hover.v-info
            icon="UserCheckIcon"
            color="info"
            :statistic="statistics.yesterday.passengers"
            statistic-title="Personen"

            style="max-width:160px"
            class="ml-2 col-3"
            title="Transportierte Fahrgäste"
            variant="outline-info"
          />
          <statistic-card-vertical
            v-ripple.400="'rgba(0, 207, 232, 0.15)'"
            v-b-tooltip.hover.v-info
            icon="NavigationIcon"
            color="info"
            :statistic="statistics.yesterday.km"
            statistic-title="KM"

            style="max-width:160px"
            class="ml-2 col-3"
            title="Zurückgelegte Kilometer mit Fahrgästen"
            variant="outline-info"
          />
          <statistic-card-vertical
            v-ripple.400="'rgba(0, 207, 232, 0.15)'"
            v-b-tooltip.hover.v-info
            icon="DollarSignIcon"
            color="info"
            :statistic="statistics.yesterday.sales"
            statistic-title="euro"

            style="max-width:350px"
            class="ml-2"
            title="Umsatz"
            variant="outline-info"
          />
          <statistic-card-vertical
            v-ripple.400="'rgba(0, 207, 232, 0.15)'"
            v-b-tooltip.hover.v-info
            icon="TruckIcon"
            color="info"
            :statistic="statistics.yesterday.voucher"
            statistic-title="Voucher"

            style="max-width:160px"
            class="ml-2 col-3"
            title="Fahrten"
            variant="outline-info"
          />
        </b-row>
      </b-col>

      <b-col cols="6">
        <h4 class="ml-1">
          Letzten 7 Tage
        </h4>
        <b-row>
          <statistic-card-vertical
            v-ripple.400="'rgba(0, 207, 232, 0.15)'"
            v-b-tooltip.hover.v-info
            icon="UserCheckIcon"
            color="info"
            :statistic="statistics.d7.passengers"
            statistic-title="Personen"

            style="max-width:160px"
            class="ml-2 col-3"
            title="Transportierte Fahrgäste"
            variant="outline-info"
          />
          <statistic-card-vertical
            v-ripple.400="'rgba(0, 207, 232, 0.15)'"
            v-b-tooltip.hover.v-info
            icon="NavigationIcon"
            color="info"
            :statistic="statistics.d7.km"
            statistic-title="KM"

            style="max-width:160px"
            class="ml-2 col-3"
            title="Zurückgelegte Kilometer mit Fahrgästen"
            variant="outline-info"
          />
          <statistic-card-vertical
            v-ripple.400="'rgba(0, 207, 232, 0.15)'"
            v-b-tooltip.hover.v-info
            icon="DollarSignIcon"
            color="info"
            :statistic="statistics.d7.sales"
            statistic-title="euro"

            style="max-width:350px"
            class="ml-2"
            title="Umsatz"
            variant="outline-info"
          />
          <statistic-card-vertical
            v-ripple.400="'rgba(0, 207, 232, 0.15)'"
            v-b-tooltip.hover.v-info
            icon="TruckIcon"
            color="info"
            :statistic="statistics.d7.voucher"
            statistic-title="Voucher"

            style="max-width:160px"
            class="ml-2 col-3"
            title="Fahrten"
            variant="outline-info"
          />
        </b-row>
      </b-col>
      <b-col cols="6">
        <h4 class="ml-1">
          Letzten 30 Tage
        </h4>
        <b-row>
          <statistic-card-vertical
            v-ripple.400="'rgba(0, 207, 232, 0.15)'"
            v-b-tooltip.hover.v-info
            icon="UserCheckIcon"
            color="info"
            :statistic="statistics.d30.passengers"
            statistic-title="Personen"

            style="max-width:160px"
            class="ml-2 col-3"
            title="Transportierte Fahrgäste"
            variant="outline-info"
          />
          <statistic-card-vertical
            v-ripple.400="'rgba(0, 207, 232, 0.15)'"
            v-b-tooltip.hover.v-info
            icon="NavigationIcon"
            color="info"
            :statistic="statistics.d30.km"
            statistic-title="KM"

            style="max-width:160px"
            class="ml-2 col-3"
            title="Zurückgelegte Kilometer mit Fahrgästen"
            variant="outline-info"
          />
          <statistic-card-vertical
            v-ripple.400="'rgba(0, 207, 232, 0.15)'"
            v-b-tooltip.hover.v-info
            icon="DollarSignIcon"
            color="info"
            :statistic="statistics.d30.sales"
            statistic-title="euro"

            style="max-width:350px"
            class="ml-2"
            title="Umsatz"
            variant="outline-info"
          />
          <statistic-card-vertical
            v-ripple.400="'rgba(0, 207, 232, 0.15)'"
            v-b-tooltip.hover.v-info
            icon="TruckIcon"
            color="info"
            :statistic="statistics.d30.voucher"
            statistic-title="Voucher"

            style="max-width:160px"
            class="ml-2 col-3"
            title="Fahrten"
            variant="outline-info"
          />
        </b-row>
      </b-col>
    </b-row>
    <b-row class="dashboard-charts">
      <b-col
        cols="12"
        xl="8"
      >
        <b-card title="Leistung im Vergleich">
          <vue-apex-charts
            type="bar"
            height="350"
            :options="performanceChartOptions"
            :series="performanceChartSeries"
          />
        </b-card>
      </b-col>
      <b-col
        cols="12"
        xl="4"
      >
        <b-card title="Umsatz im Vergleich">
          <vue-apex-charts
            type="area"
            height="350"
            :options="salesChartOptions"
            :series="salesChartSeries"
          />
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12">
        <DriverStats />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BCard, BRow, BCol, VBTooltip,
} from 'bootstrap-vue'
import StatisticCardVertical from '@core/components/statistics-cards/StatisticCardVertical.vue'
import Ripple from 'vue-ripple-directive'

import VueApexCharts from 'vue-apexcharts'
import DriverStats from '@/views/stats/DriverStats.vue'

export default {
  components: {
    VueApexCharts,
    DriverStats,
    BCard,
    BRow,
    BCol,
    StatisticCardVertical,
  },
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },
  data() {
    return {
      statistics: {
        d365: {
          passengers: 0,
          km: 0,
          sales: 0,
          voucher: 0,
        },
        d7: {
          passengers: 0,
          km: 0,
          sales: 0,
          voucher: 0,
        },
        d30: {
          passengers: 0,
          km: 0,
          sales: 0,
          voucher: 0,
        },
        today: {
          passengers: 0,
          km: 0,
          sales: 0,
          voucher: 0,
        },
        yesterday: {
          passengers: 0,
          km: 0,
          sales: 0,
          voucher: 0,
        },
      },
      chartStatistics: {
        today: {
          passengers: 0, km: 0, sales: 0, voucher: 0,
        },
        yesterday: {
          passengers: 0, km: 0, sales: 0, voucher: 0,
        },
        d7: {
          passengers: 0, km: 0, sales: 0, voucher: 0,
        },
        d30: {
          passengers: 0, km: 0, sales: 0, voucher: 0,
        },
      },
    }
  },
  computed: {
    performanceChartSeries() {
      const periods = ['today', 'yesterday', 'd7', 'd30']
      return [
        {
          name: 'Fahrten',
          data: periods.map(period => this.chartStatistics[period].voucher),
        },
        {
          name: 'Personen',
          data: periods.map(period => this.chartStatistics[period].passengers),
        },
        {
          name: 'Kilometer',
          data: periods.map(period => this.chartStatistics[period].km),
        },
      ]
    },
    salesChartSeries() {
      const periods = ['today', 'yesterday', 'd7', 'd30']
      return [{
        name: 'Umsatz',
        data: periods.map(period => this.chartStatistics[period].sales),
      }]
    },
    performanceChartOptions() {
      return {
        chart: {
          toolbar: { show: false },
          fontFamily: 'Montserrat, Helvetica, Arial, serif',
        },
        colors: ['#7367f0', '#28c76f', '#00cfe8'],
        dataLabels: { enabled: false },
        plotOptions: {
          bar: {
            borderRadius: 4,
            columnWidth: '55%',
          },
        },
        stroke: {
          show: true,
          width: 2,
          colors: ['transparent'],
        },
        xaxis: {
          categories: ['Heute', 'Gestern', '7 Tage', '30 Tage'],
        },
        yaxis: {
          min: 0,
          labels: {
            formatter: value => Math.round(value).toLocaleString('de-DE'),
          },
        },
        tooltip: {
          y: {
            formatter: value => Number(value).toLocaleString('de-DE'),
          },
        },
        legend: {
          position: 'top',
          horizontalAlign: 'left',
        },
        noData: { text: 'Keine Daten verfügbar' },
      }
    },
    salesChartOptions() {
      return {
        chart: {
          toolbar: { show: false },
          fontFamily: 'Montserrat, Helvetica, Arial, serif',
        },
        colors: ['#ff9f43'],
        dataLabels: { enabled: false },
        fill: {
          type: 'gradient',
          gradient: {
            shadeIntensity: 0.4,
            opacityFrom: 0.45,
            opacityTo: 0.08,
          },
        },
        stroke: {
          curve: 'smooth',
          width: 3,
        },
        markers: {
          size: 5,
        },
        xaxis: {
          categories: ['Heute', 'Gestern', '7 Tage', '30 Tage'],
        },
        yaxis: {
          min: 0,
          labels: {
            formatter: value => `${Number(value).toLocaleString('de-DE', {
              maximumFractionDigits: 0,
            })} €`,
          },
        },
        tooltip: {
          y: {
            formatter: value => Number(value).toLocaleString('de-DE', {
              style: 'currency',
              currency: 'EUR',
            }),
          },
        },
        noData: { text: 'Keine Daten verfügbar' },
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      document.title = 'FSRPro Dashboard'
    })
    this.Load()
  },
  methods: {
    setStatistics(period, data) {
      const values = {
        voucher: Number(data.count) || 0,
        passengers: Number(data.passengers) || 0,
        km: (Number(data.km) || 0) / 1000,
        sales: Number(data.sales) || 0,
      }

      this.chartStatistics[period] = values
      this.statistics[period].voucher = values.voucher
      this.statistics[period].passengers = values.passengers
      this.statistics[period].km = values.km.toFixed(0)
      this.statistics[period].sales = this.$options.filters.currency(values.sales)
    },
    Load() {
      const yesterday = new Date()
      yesterday.setDate(yesterday.getDate() - 1)
      this.$http.get(`/statistics/sales?from=${yesterday.toISOString()
        .slice(0, 10)}&to=${yesterday.toISOString()
        .slice(0, 10)}`)
        .then(resp => {
          this.setStatistics('yesterday', resp.data.statistics)
        })
        .catch(err => {
          console.error(err)
        })
      const today = new Date()
      this.$http.get(`/statistics/sales?from=${today.toISOString()
        .slice(0, 10)}&to=${today.toISOString()
        .slice(0, 10)}`)
        .then(resp => {
          this.setStatistics('today', resp.data.statistics)
        })
        .catch(err => {
          console.error(err)
        })

      const last7day = new Date()
      last7day.setDate(last7day.getDate() - 7)
      this.$http.get(`/statistics/sales?from=${last7day.toISOString()
        .slice(0, 10)}&to=${today.toISOString()
        .slice(0, 10)}`)
        .then(resp => {
          this.setStatistics('d7', resp.data.statistics)
        })
        .catch(err => {
          console.error(err)
        })

      const last30day = new Date()
      last30day.setDate(last30day.getDate() - 30)
      this.$http.get(`/statistics/sales?from=${last30day.toISOString()
        .slice(0, 10)}&to=${today.toISOString()
        .slice(0, 10)}`)
        .then(resp => {
          this.setStatistics('d30', resp.data.statistics)
        })
        .catch(err => {
          console.error(err)
        })
    },
  },
}
</script>

<style scoped>
.dashboard-charts {
  margin-top: 1rem;
}
</style>
